import { IEntity } from '../state/entities/entity';
import { FullName } from '@core/services/api-client.generated';

export const Auth0Provider = 'auth0';
export const GoogleProvider = 'google-oauth2';
export const AppleProvider = 'apple-oauth2';
export const FacebookProvider = 'facebook-oauth2';

export enum Providers {
  Auth0 = 'auth0',
  Google = 'google-oauth2',
  Apple = 'apple-oauth2',
  Facebook = 'facebook-oauth2',
}

export type Provider =
  | typeof Providers.Auth0
  | typeof Providers.Google
  | typeof Providers.Apple
  | typeof Providers.Facebook;
export interface Identity {
  /**
   * Provider key exactly as projected by the account-management endpoint.
   * Deliberately a plain string, not the `Provider` union: native sign-in
   * methods (e.g. `custom-oidc`) are legitimate values that the union does
   * not enumerate, and narrowing here would require an unsound cast at the
   * projection boundary. `Provider` stays the narrow union for the
   * Auth0-only connect/disconnect controls, which only ever act on the
   * providers SyRF itself offers.
   */
  provider: string;
  user_id: string;
  connected_at: string;
  picture: string;
}

export interface IAuthenticatedUser extends IUser {
  syrf_groups: string[];
  identities: Identity[];
  sub: string;
  fullAuth0: boolean;
}

export interface IUser extends IEntity {
  fullName: FullName;
  email: string;
  pictureUrl: string;
}
